import { DO_LOGOUT } from '../Login/actions';
import { SORT_PLAYLISTS } from './actions'

const inititalState = {
    sort_type: "",
    direction: "",
    id: "",
    playlists: ""
}

const reducer = (state = inititalState, { type, payload }) => {
    switch (type) {

        case SORT_PLAYLISTS:
            return {
                ...state,
                playlists: state.playlists.allPlaylists.sort((a, b) => a.name < b.name),
            }
            case DO_LOGOUT:
                return inititalState;
    }
    return state
}

export default reducer